import validator from 'validator';

const urlValidator = (url) => {
  const isHTTPS = {
    protocols: ['https'],
    require_protocol: true,
  };

  return validator.isURL(url.trim(), isHTTPS);
};

const callbackUriValidator = s => !!s && s.length > 0 && s.length <= 255 && urlValidator(s);

const nameValidator = (s, min = 3, max = 30) => !!s && s.length >= min && s.length <= max;

export {
  urlValidator,
  callbackUriValidator,
  nameValidator,
};
